<template>
  <!-- clase move creada para cambiar el cursor a move -->
  <b-row class="grab">
    <b-col class="col-main-pad">
      <b-row>
        <b-col lg="12" class="col-head-activity">
          <font-awesome-icon icon="link" />&nbsp; Configurar Relacionar Palabras
        </b-col>
        <b-col lg="12">
          <b-form-group>
            <label for="name">Instrucciones de la Actividad</label>
            <b-form-textarea
              v-model="instrucciones"
              placeholder="Ingrese las Instrucciones para Realizar la Actividad"
              rows="2"
              max-rows="3"
            ></b-form-textarea>
          </b-form-group>
        </b-col>

        <b-col lg="12">
          <b-form-group>
            <label for="name">No. de Elementos</label>
            <b-form-select
              :value="defaultSelected"
              id="elementosNumero"
              class="border-visible"
              :options="noElementos"
              @change="onChangeElementos($event)"
              variant="primary"
            >
              <template slot="first">
                <option :value="null" disabled>Seleccione un Número</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col lg="3" v-for="(elemento,index) in elementosSelected" :key="elemento.id">
          <b-card show-header show-footer>
            <div>
              <p>
                <strong>Contenido</strong>
                <i class="icon-close close-style" @click="removeElemento(index)"></i>
              </p>
              <b-form-select
                :value="elemento.tipo"
                :id="`elementoTipo-${elemento.id}`"
                :options="tipos"
                :name="`elementoTipo-${elemento.id}`"
                @change="onChangeTipo($event, elemento)"
              ></b-form-select>
            </div>
            <div v-if="elemento.tipo == 1" style="height: 185px;">
              <b-form-textarea
                style="text-align: center; margin-top: 50px;"
                id="textarea"
                v-model="elemento.data"
                placeholder="Agregue Texto"
                rows="8"
                max-rows="8"
              ></b-form-textarea>
            </div>
            <div v-if="elemento.tipo == 2">
              <button
                type="button"
                class="btn btn-primary"
                style="margin-top: 20px; width: 100%;"
                @click="openModalRecursos('IMAGEN',elemento)"
              >Seleccionar un Recurso</button>
              <div id="preview">
                <b-img
                  v-if="elemento.data != ''"
                  thumbnail
                  fluid
                  :src="$root.setUrlFile(elemento.data)"
                  alt="Imagen"
                  style="width: 160px; height: 160px;"
                ></b-img>
              </div>
            </div>
            <div v-if="elemento.tipo == 3">
              <!--<b-form-file
                placeholder="Seleccione un Audio"
                @change="onFileChange($event, elemento)"
              ></b-form-file>-->
              <button
                type="button"
                class="btn btn-primary"
                style="margin-top: 20px; width: 100%;"
                @click="openModalRecursos('AUDIO',elemento)"
              >Seleccionar un Recurso</button>
              <div id="preview" style="height: 160px;">
                <audio
                  v-if="elemento.data != ''"
                  controls="controls"
                  autobuffer="autobuffer"
                  autoplay="autoplay"
                  style="margin-top: 50px; width: 100%;"
                >
                  <source :src="$root.setUrlFile(elemento.data)" />
                </audio>
              </div>
            </div>
            <div slot="footer">
              <b-form-input
                v-model="elemento.respuesta"
                type="text"
                placeholder="Ingrese la Respuesta"
              ></b-form-input>
            </div>
          </b-card>
        </b-col>
        <b-col lg="12" style="text-align: right;">
          <button type="button" class="btn btn-primary" @click="newElemento">
            <i class="icon-plus"></i>&nbsp;Nuevo Elemento
          </button>
        </b-col>
      </b-row>
    </b-col>

    <!--<b-col lg="3" v-for="(elemento,index) in elementosSelected" :key="elemento.id">
          <b-card show-header show-footer class="border-visible">
            <div slot="header">
              <i class="icon-close close-style" @click="removeElemento(index)"></i>
              <b-form-select
                :value="elemento.tipo"
                :id="`elementoTipo-${elemento.id}`"
                :options="tipos"
                :name="`elementoTipo-${elemento.id}`"
                @change="onChangeTipo($event, elemento)"
              ></b-form-select>
            </div>
            <div v-if="elemento.tipo == 1" style="height: 220px;">
              <b-form-textarea
                style="text-align: center; margin-top: 50px;"
                id="textarea"
                v-model="elemento.data"
                placeholder="Agregue Texto"
                rows="8"
                max-rows="8"
              ></b-form-textarea>
            </div>
            <div v-if="elemento.tipo == 2">
              <button
                type="button"
                class="btn btn-primary"
                style="margin-top: 20px; width: 100%;"
                @click="openModalRecursos('IMAGEN',elemento)"
              >Seleccionar un Recurso</button>
              <div id="preview">
                <b-img
                  v-if="elemento.data != ''"
                  thumbnail
                  fluid
                  :src="$root.setUrlFile(elemento.data)"
                  alt="Imagen"
                  style="width: 160px; height: 160px;"
                ></b-img>
              </div>
            </div>
            <div v-if="elemento.tipo == 3">
              <!<b-form-file
                placeholder="Seleccione un Audio"
                @change="onFileChange($event, elemento)"
              ></b-form-file>--
              <button
                type="button"
                class="btn btn-primary"
                style="margin-top: 20px; width: 100%;"
                @click="openModalRecursos('AUDIO',elemento)"
              >Seleccionar un Recurso</button>
              <div id="preview" style="height: 160px;">
                <audio
                  v-if="elemento.data != ''"
                  controls="controls"
                  autobuffer="autobuffer"
                  autoplay="autoplay"
                  style="margin-top: 50px; width: 100%;"
                >
                  <source :src="$root.setUrlFile(elemento.data)" />
                </audio>
              </div>
            </div>
            <div slot="footer">
              <b-form-input
                v-model="elemento.respuesta"
                type="text"
                placeholder="Ingrese la Respuesta"
              ></b-form-input>
            </div>
          </b-card>
    </b-col>-->

    <!-- componente de botón de opciones del elemento  -->
    <options-element :index-element="idElement" :index-column="idColumn"></options-element>
    <!-- Modal recursos -->
    <ModalRecursos
      :showModal="showModal"
      v-on:closeModal="showModal = $event"
      :typeRecurso="typeRecurso"
      v-on:data-selected="chooseRecurso($event)"
    ></ModalRecursos>
  </b-row>
</template>

<script>
var arry = new Array(13);
var noElementos = [];
for (let i = 1; i < arry.length; i++) {
  noElementos.push(i);
}
import ModalRecursos from "@/components/ModalRecursos/";
import OptionsElement from "./OptionsElement";
export default {
  name: "RelacionarContent",
  props: {
    elementos: {
      type: Array,
      default: () => {
        return new Array();
      }
    },
    desc: { type: String },
    idElement: { type: Number },
    idColumn: { type: Number, default: null }
  },
  data() {
    return {
      instrucciones: this.desc,
      defaultSelected: null,
      elementosSelected: this.elementos,
      noElementos: noElementos,
      tipos: [
        { value: null, text: "Seleccione un Tipo", disabled: true },
        { value: 1, text: "Texto" },
        { value: 2, text: "Imagen" },
        { value: 3, text: "Audio" }
      ],
      showModal: false,
      typeRecurso: null,
      dataProcessModal: null
    };
  },
  components: {
    ModalRecursos,
    OptionsElement
  },
  methods: {
    openModalRecursos(tipo, elemento) {
      this.typeRecurso = tipo;
      this.showModal = true;
      this.dataProcessModal = elemento;
    },
    chooseRecurso(e) {
      this.dataProcessModal.data = e.file;
    },
    onChangeElementos(number) {
      this.elementosSelected = [];
      var elementosArry = new Array(number);
      for (let i = 0; i < elementosArry.length; i++) {
        var elementoData = {
          id: i + 1,
          tipo: null,
          data: "",
          respuesta: ""
        };
        this.elementosSelected.push(elementoData);
      }
    },
    onChangeTipo(event, elemento) {
      console.log(elemento);
      elemento.data = "";
      elemento.tipo = event;
    },
    onFileChange(e, elemento) {
      var f = e.target.files[0]; // FileList object
      var type = e.target.files[0].type;
      var reader = new FileReader();
      // Closure to capture the file information.
      reader.onload = (function(theFile) {
        return function(e) {
          var binaryData = e.target.result;
          var base64String = window.btoa(binaryData);
          elemento.data = `data:${type};base64,${base64String}`;
        };
      })(f);
      reader.readAsBinaryString(f);
    },
    removeElemento(index) {
      this.$swal({
        type: "warning",
        title: "Eliminar un Elemento",
        text: `¿Seguro que Deseas Eliminar el Elemento No. ${index + 1}?`,
        showCancelButton: true,
        confirmButtonColor: "#285c4d",
        cancelButtonColor: "#aaa",
        confirmButtonText: "Sí, Eliminar",
        cancelButtonText: "No, Cancelar"
      }).then(result => {
        if (result.value) {
          this.elementosSelected.splice(index, 1);
        }
      });
    },
    newElemento() {
      var i = this.elementosSelected.length;
      var elementoData = {
        id: i + 1,
        tipo: null,
        data: "",
        respuesta: ""
      };
      this.elementosSelected.push(elementoData);
    }
  },
  watch: {
    elementosSelected: {
      handler: function(change) {
        this.$store.dispatch("constructor/updateContentElement", {
          indexElement: this.idElement,
          data: change,
          field: "elementos",
          indexColumns: this.idColumn
        });
      },
      deep: true
    },
    instrucciones: function(change) {
      this.$store.dispatch("constructor/updateContentElement", {
        indexElement: this.idElement,
        data: change,
        field: "instrucciones",
        indexColumns: this.idColumn
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#textarea {
  resize: none;
}
#preview {
  margin-top: 20px;
  text-align: center;
}
.elementosToMatch {
  width: 100%;
  height: auto;
  background-color: #eee;
  cursor: pointer;
  text-align: center;
  min-height: 30px;
  font-size: 16px;
  line-height: 30px;
}
.listaRespuestas {
  height: auto;
  background-color: #eee;
  border: 1px solid #aaaaaa;
  cursor: pointer;
  text-align: center;
  font-size: 16px;
  margin-top: 20px;
  min-height: 30px;
  line-height: 30px;
}
.correcta {
  border: 1px solid green;
}
.incorrecta {
  border: 1px solid red;
}
input .custom-file-input {
  cursor: pointer !important;
}
</style>